import { render, staticRenderFns } from "./OrderPricePopup.vue?vue&type=template&id=0b3d58ac&scoped=true"
import script from "./OrderPricePopup.vue?vue&type=script&lang=js"
export * from "./OrderPricePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d58ac",
  null
  
)

export default component.exports